<template>
  <div id="app" class="d-flex align-items-center">
    <b-container class="bv-example-row">
      <b-row>
        <b-col sm="10" offset="1">
          <QuestionBox
              v-if="Object.keys(questions).length"
              :currentQuestion="questions[index]"
              :index="index"
              :totalLength="totalQuestions()"
              :next="next"
              :score="getScore"
          />
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>

import QuestionBox from './components/QuestionBox.vue'

export default {
  name: 'app',
  components: {
    QuestionBox
  },
  data() {
    return {
      questions: {},
      index: "city",
      index2: "working",
      totalLength: 0,/* чтобы узнать, когда мы придем к концу опроса и показать форму обраттной связи */
      score: '0%'
    }
  },
  methods: {
    next(selectedIndex) {
      //console.log(selectedIndex);

        //console.log(this.questions[this.index].answers);
          console.log(this.questions[this.index].score);
          if(this.questions[this.index].hasOwnProperty('score')
              && Array.isArray(this.questions[this.index].score)){
            this.score = this.questions[this.index].score[selectedIndex];
          }
          let route = null;
          if (selectedIndex != null) {
            if (this.questions[this.index].hasOwnProperty('routes')
                && Array.isArray(this.questions[this.index].routes)
                && this.questions[this.index].routes.hasOwnProperty(selectedIndex)) {
              console.log(this.questions[this.index].routes[selectedIndex]);
              route = this.questions[this.index].routes[selectedIndex];

            }
          }

        this.index = route !== null
            ? route
            : this.questions[this.index].next;
        console.log('route_index: '+ route);

      return  this.index; //next
    },
    getScore(){
      return this.score;
    },
    totalQuestions() {
      return 10;//this.totalLength = this.questions.length
    }
  },
  mounted: function () {
    //fetch('https://opentdb.com/api.php?amount=10&type=multiple',{

    fetch(`questions.json?timestamp=${Date.now()}`, {
      method: 'get'
    }).then((response) => {
      return response.json()
    }).then((jsonData) => {
      console.log(jsonData.results);
      this.questions = jsonData.results
    })
  }
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 24px;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  height: 100%;
}

.nav-tabs {
  margin: 10px 0
}
</style>
